import { render, staticRenderFns } from "./EditMerchantInterfaceField.vue?vue&type=template&id=610a290e&scoped=true"
import script from "./EditMerchantInterfaceField.vue?vue&type=script&lang=js"
export * from "./EditMerchantInterfaceField.vue?vue&type=script&lang=js"
import style0 from "./EditMerchantInterfaceField.vue?vue&type=style&index=0&id=610a290e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a290e",
  null
  
)

export default component.exports